import type { ICustomControlProcedureReadProps } from '../../interfaces';
import { translateKey } from '../../../../../translate';
import { FormParagraph, HeaderDivider, UserTextParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';

export function TcohV2ProcedureSummary(props: ICustomControlProcedureReadProps) {
    const procedureType = props.procedure.customControlData.procedureType;
    const durationKey = `${procedureType}CardioExaminationDuration`;

    return (
        <>
            <HeaderDivider text="Holterinstellingen" />

            {procedureType && (
                <HorizontalFormGroupRead>
                    <FormLabel>Type onderzoek</FormLabel>
                    <InputContainer>
                        <FormParagraph>{translateKey(`tcohProcedureTypeEnum.${procedureType}`)}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
            {procedureType && props.procedure.customControlData[durationKey] && (
                <HorizontalFormGroupRead>
                    <FormLabel>Opnameduur</FormLabel>
                    <InputContainer>
                        <FormParagraph>
                            {translateKey(
                                `${procedureType}CardioExaminationDurationEnum.${props.procedure.customControlData[durationKey]}`
                            )}
                        </FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
            {props.procedure.customControlData.vraagstelling && (
                <HorizontalFormGroupRead>
                    <FormLabel>Vraag</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.procedure.customControlData.vraagstelling}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}
        </>
    );
}
